import { render, staticRenderFns } from "./PostSearchBreadcrumbs.vue?vue&type=template&id=0cb82443&scoped=true&"
import script from "./PostSearchBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./PostSearchBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./PostSearchBreadcrumbs.vue?vue&type=style&index=0&id=0cb82443&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb82443",
  null
  
)

export default component.exports